export default "/fonts/vendor/summernote/dist/summernote.ttf?b293d601cf1cddd1a1b40941d9cbd683";